import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-facilitator',
  templateUrl: './delete-facilitator.component.html',
  styleUrls: ['./delete-facilitator.component.scss']
})
export class DeleteFacilitatorComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<DeleteFacilitatorComponent>
  ) { }
  ngOnInit(): void { }

  public close(value: boolean): void {
    this.dialogRef.close(value);
  }
}
